<template>
  <div>
    <v-row>
      <v-col md="5" class="pb-0 hidden-sm-and-down">
        <v-img
          height="100vh"
          :src="registerDogImage"
          class="sticky-image"
        />
      </v-col>
      <affiliate-address
        v-if="this.currentPage === 1"
        :changePage="changePage"
        :clubName="clubName"
        :address="address"
        :termOfOffice="termOfOffice"
        :affiliateWebsite="affiliateWebsite"
        :changeFirstPageInfo="changeFirstPageInfo"
        :price="fee"
        :memberTypesLoaded="memberTypesLoaded"
      />
      <affiliate-members
        v-if="this.currentPage === 2"
        title="New Affiliate Application"
        showAscaObligations
        showObligations
        :changePage="changePage"
        :affiliatePeople="affiliatePeople"
        :affiliateMemberTypes="affiliateMemberTypes"
        :membershipTypes="membershipTypes"
        :changeAffiliatePeople="changeAffiliatePeople"
      />
      <affiliate-payment
        v-if="this.currentPage === 3"
        title="New Affiliate Application"
        :changePage="changePage"
        :submitRequest="submitRequest"
        :fee="fee"
        :feeInfo="feeInfo"
        :status="registrationRequestStatus"
      />
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import AffiliateAddress from "./Steps/AffiliateAddress.vue";
import AffiliateMembers from "./Steps/AffiliateMembers.vue";
import AffiliatePayment from "./Steps/AffiliatePayment.vue";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";
import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";
import registerAffiliateService from "@/services/portal/registerAffiliateService";
import reducePeopleToAffiliateMembers from "@/helpers/reduce-people-to-affiliate-members";
import normalizeAddressRegion from "@/helpers/normalize-address-region";

const registerDogImage = require('@/assets/register-dog.png');

export default Vue.extend({
  name: "RegisterAffiliate",
  components: {
    AffiliateAddress,
    AffiliateMembers,
    AffiliatePayment,
  },
  data: function () {
    return {
      registerDogImage,
      currentPage: 1,
      fee: null as number | null,
      feeInfo: { fullMemberPrice: 0, serviceMemberPrice: 0 },
      clubName: "",
      affiliateWebsite: "",
      address: {
        street: "",
        city: "",
        state: "",
        zip: "",
        international: "",
        country: "",
      },
      termOfOffice: null as any,
      affiliatePeople: [],
      registrationRequestStatus: {},
      affiliateMemberTypes: {},
      memberTypesLoaded: false,
      membershipTypes: { Single: 1, Dual: 2, Affiliate: 3, Junior: 4, Service: 5, Lifetime: 6 },
    };
  },
  created: function () {
    registerAffiliateService.getAffiliateMemberTypes().then((res: any) => {
      this.affiliateMemberTypes = res.memberTypes;
      this.memberTypesLoaded = true;
    }).catch(this.$handleError);
    workflowService.getRegisterAffiliateFees().then((res) => {
      if (!isNaN(res)) {
        this.feeInfo = { fullMemberPrice: res, serviceMemberPrice: res };
        this.fee = res;
      } else {
        this.feeInfo = res;
      }
    }).catch(this.$handleError);
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    changePage(page: number) {
      if (page > 1 && !this.memberTypesLoaded) return;
      this.currentPage = page;
    },
    changeFirstPageInfo(firstPageInfo: {
      clubName: string;
      address: any;
      termOfOffice: number;
      affiliateWebsite: string;
    }) {
      this.clubName = firstPageInfo.clubName;
      this.address = firstPageInfo.address;
      this.termOfOffice = firstPageInfo.termOfOffice;
      this.affiliateWebsite = firstPageInfo.affiliateWebsite;
    },
    changeAffiliatePeople(affiliatePeople: any) {
      this.affiliatePeople = affiliatePeople;
    },
    submitRequest(paymentInfo: AuthorizeNetResponseData, signature: string) {
      const region = normalizeAddressRegion(
        this.address.country,
        this.address.state,
        this.address.international
      );
      this.address.state = region.state;
      this.address.international = region.international;

      const request = {
        paymentInfo,
        requesterSignatureText: signature,
        affiliateName: this.$data.clubName,
        affAddress: this.$data.address,
        fee: this.fee,
        affiliateWebsite: this.$data.affiliateWebsite,
        termOfOffice: parseInt(this.$data.termOfOffice),
        affMembers: reducePeopleToAffiliateMembers(
          this.$data.affiliatePeople,
          this.$data.affiliateMemberTypes
        ),
      };

      registerAffiliateService.registerAffiliate(request).then((response) => {
        this.registrationRequestStatus = response;
      }).catch((error) => {
        this.registrationRequestStatus = error;
      });
    },
  },
});
</script>
